import {Bounds, Coords} from 'google-map-react';


export function isPointInBounds(bound: Bounds, point: Coords): boolean {
    const ptInSect = (x: number, a: number, b: number) => (x - a) * (x - b) <= 0;

    const {nw, se} = bound;

    const lngs = nw.lng < se.lng
        ? [[nw.lng, se.lng]]
        : [[nw.lng, 180], [-180, se.lng]];

    return ptInSect(point.lat, se.lat, nw.lat) &&
        lngs.some(([lngFrom, lngTo]) => ptInSect(point.lng, lngFrom, lngTo));

}

export function getBoundsForCoords(coordinates: Coords[]): google.maps.LatLngBounds {
    let bounds = new google.maps.LatLngBounds();

    coordinates.forEach(coordinate => {
        bounds.extend(new google.maps.LatLng(coordinate.lat, coordinate.lng))
    });

    return bounds;
}